

export const translations = {
    'Maximize your competitive advantage before applying': 'Tối ưu lợi thế cạnh tranh trước khi ứng tuyển',
    'View matching analysis and compare to other applicants': 'Xem phân tích mức độ phù hợp và so sánh với ứng viên đã ứng tuyển',
    'Over 90% of users are satisfied': 'Hơn 90% người dùng hài lòng',
    'View analysis now': 'Xem phân tích ngay'
} as const
export type TTranslationKey = keyof typeof translations
